/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    oldPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    newPassword?: string | null;
}

export function UpdatePasswordRequestFromJSON(json: any): UpdatePasswordRequest {
    return UpdatePasswordRequestFromJSONTyped(json, false);
}

export function UpdatePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldPassword': !exists(json, 'oldPassword') ? undefined : json['oldPassword'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function UpdatePasswordRequestToJSON(value?: UpdatePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oldPassword': value.oldPassword,
        'newPassword': value.newPassword,
    };
}


